// Orders
export const SUCCESS_FETCH_ORDERS = "SUCCESS_FETCH_ORDERS";

// States
export const SUCCESS_FETCH_STATES = "SUCCESS_FETCH_STATES";

// Login
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
